import { useMutation, useQuery } from "@tanstack/react-query";
import { BoxLabelApiService } from "./boxlabel.api";

export const useBoxLabelService = (payload: any) => {
    const InsertReprintHistoryMutation = useMutation({
        mutationFn: (payload: any) => BoxLabelApiService.insertHistory(payload),
    });

        // SELECT ALL BOX LABEL QUERY
    const SelectAllQuery = useQuery({
        queryKey: ["box-label-SelectAll", payload.studyid, payload.period, payload.aliquot, payload.currentpage, payload.pagesize, payload.searchtext],
        queryFn: () => BoxLabelApiService.selectAll(payload),
        enabled: !!(payload.studyid && payload.period && payload.aliquot && (Array.isArray(payload.aliquot) ? payload.aliquot.length > 0 : true)),
    });

    // UPDATE BOX LABEL MUTATION
    const UpdateBoxLabelMutation = useMutation({
        mutationFn: (payload: any) => BoxLabelApiService.updateLabel(payload),
    });


    return {
        InsertReprintHistoryMutation,
        SelectAllQuery,
        UpdateBoxLabelMutation,
    };
};
